import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { ChatService } from '../../../services/chat.service';
import { SharedService } from '../../../services/shared.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-chat',
  standalone: false,
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.css'
})
export class ChatComponent {
  @ViewChild('search') private messageContainer!: ElementRef;
  public shareObject: any = {
    isLoading: false,
    isMessageLoading: false,
    messages: [],
    page: 1,
    roomId: null,
    memberSelected: [],
  };
  constructor(
    public sharedService: SharedService,
    public chatService: ChatService,
    private activatedRoute: ActivatedRoute,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private router: Router,
  ) {
    this.activatedRoute.params.subscribe((params) => {
      this.shareObject.roomId = params['id'];
      this.changeRoom();
    })
  }
  ngOnInit(): void {
    // đổi manifest.webmanifest thành manifest-chat.webmanifest
    this.sharedService.setManifest('manifest-chat.webmanifest');
  }
  searchUser(element: any) {
    console.log('searchUser', element.target.value);
    if (element.target.value.length === 0) {
      this.shareObject.searchUserList = null;
      return;
    }
    if (element.target.value.length > 0 && this.shareObject.searchUserkeyword === element.target.value) {
      return;
    }
    this.shareObject.searchUserList = null;
    if (this.shareObject.searchTyping) {
      clearTimeout(this.shareObject.searchTyping);
    }
    this.shareObject.searchTyping = setTimeout(() => {
      if (element.target.value.length > 0) {
        this.chatService.searchUser(element.target.value).subscribe((data: any) => {
          this.shareObject.searchUserList = data.data;
          this.shareObject.searchUserkeyword = element.target.value;
        })
      }
      this.shareObject.searchTyping = null;
    }, 100);
  }
  onScrollUp(event: any) {
    this.shareObject.container = event.target;
    if (!this.shareObject.isMessageLoading && event.target.scrollTop === 0) {
      this.loadOlderMessages();
    }
  }
  loadOlderMessages() {
    this.shareObject.page++;
    this.shareObject.isMessageLoading = true;
    this.shareObject.oldScrollHeight = this.shareObject.container.scrollHeight;
    this.chatService.getMessages(this.shareObject.room, this.shareObject.page).subscribe((messages: any) => {
      const newMessages = messages.filter((msg: any) => !this.shareObject.messages.some((existing: any) => existing.id === msg.id));
      this.shareObject.messages = [...newMessages, ...this.shareObject.messages].sort((a: any, b: any) => {
        return a.createdAt - b.createdAt;
      });
      this.shareObject.isMessageLoading = false;
      this.cdRef.detectChanges();
      setTimeout(() => {
        const newScrollHeight = this.shareObject.container.scrollHeight;
        this.shareObject.container.scrollTop = newScrollHeight - this.shareObject.oldScrollHeight;
      }, 0);
    });
  }
  selectRoom(room: any) {
    this.router.navigate(['/user/chat', room.id]);
  }
  selectUser(userId: any) {
    this.shareObject.searchUserList = null;
    this.shareObject.searchTyping = null;
    let user = this.chatService.getParticipant(userId);
    this.chatService.selectParticipant(userId).subscribe((room: any) => {
      this.router.navigate(['/user/chat', room.id]);
    });
  }
  selectMember(member: any) {
    if (this.shareObject.memberSelected.includes(member)) {
      this.shareObject.memberSelected = this.shareObject.memberSelected.filter((u: any) => u.id !== member.id);
    } else {
      this.shareObject.memberSelected.push(member);
    }
  }
  sendMessage(el: any) {
    if (el.value.length > 0) {
      this.chatService.sendMessage(this.shareObject.room.id, el.value.trim());
      el.value = '';
    }
  }

  scrollToBottom() {
    setTimeout(() => {
      document.querySelector('.chat-messages')?.scrollTo(0, document.querySelector('.chat-messages')?.scrollHeight || 0);
    }, 100);
  }
  changeRoom() {
    let room = this.shareObject.rooms?.find((r: any) => r.id === this.shareObject.roomId);
    if (room) {
      this.shareObject.page = 1;
      this.shareObject.room = room;
      this.shareObject.isMessageLoading = true;
      this.chatService.getMessages(room.id).subscribe((messages: any) => {
        this.shareObject.messages = messages.sort((a: any, b: any) => {
          return a.createdAt - b.createdAt;
        });
        this.shareObject.isMessageLoading = false;
        this.scrollToBottom();
      });
    }
  }
  addMember() {
    console.log('addMember', this.shareObject.room);
    this.chatService.addMember(this.shareObject.room, this.shareObject.memberSelected).subscribe((room: any) => {
      console.log('addMember', room);
      this.shareObject.room.participants = [...this.shareObject.room.participants, ...room.participants];
      this.sharedService.modalControl('#add-member', false)
      // this.router.navigate(['/user/chat', room.id]);
    });
  }
  removeMember(participant: any) {
    this.chatService.removeMember(this.shareObject.room, participant).subscribe(({ room, participant }) => {
      this.shareObject.room.participants = this.shareObject.room.participants.filter((p: any) => p.id !== participant);
      // this.router.navigate(['/user/chat', room.id]);
    });
  }
  ngAfterViewInit(): void {
    setTimeout(() => {
      this.sharedService.shareObject.sidebarOpen = false;
    }, 100);
    this.chatService.shareObject.outgoing = false;
    this.chatService.listenForMessages().subscribe((message: any) => {
      this.shareObject.rooms.find((r: any) => r.id === message.room).lastMessage = message;
      if (this.shareObject.room && message.room === this.shareObject.room?.id) {
        console.log('new-message', message);
        this.shareObject.messages.push(message);
        this.shareObject.messages.sort((a: any, b: any) => {
          return a.createdAt - b.createdAt;
        });
        this.scrollToBottom();
      }
    });
    this.chatService.getRooms().subscribe((rooms: any) => {
      this.shareObject.rooms = rooms.map((r: any) => {
        let participant = r.participants.find((p: any) => p.id !== this.sharedService.user.id);
        r.data.name = r?.data?.name || participant?.profile?.name;
        r.data.avatar = r?.data?.avatar || participant?.profile?.avatar;
        return r;
      });
      console.log('this.shareObject.rooms', this.shareObject.rooms);
      if (this.shareObject.roomId) {
        this.changeRoom();
      }
    });
  }
  toggleMemberPanel(event: MouseEvent) {
    event.preventDefault();
    this.shareObject.showMemberPanel = !this.shareObject.showMemberPanel;
  }
  ngOnDestroy(): void {
    this.chatService.shareObject.outgoing = true;
    this.sharedService.setManifest('manifest.webmanifest');
  }


}


